import { useCallback, useContext, useEffect, useState } from 'react';
import refreshTimes from '../../../../packages/constants/refreshTimes';
import useInterval from '../../../../packages/hooks/useInterval';
import { IPlayoffProps, ITennisPlayoffConfig, ITennisPlayoffResponse } from '../../../../packages/types';
import TennisApiContext from '../contexts/TennisApiContext';
import { IGeneralSubscriberInfo } from '../../../../packages/constants/subscribeTypes';
import useSubscriptionClick from '../../../../packages/hooks/useSubscriptionClick';

interface IUsePlayoffArgs extends IGeneralSubscriberInfo {
  tournamentId?: string;
  dataRefreshTime?: ITennisPlayoffConfig['dataRefreshTime'];
}
export default function usePlayoff({
  tournamentId,
  subscribers,
  dataWidgetId,
  dataWidgetSport,
  dataRefreshTime,
  dataWidgetCuid,
}: IUsePlayoffArgs) {
  const { $playoff } = useContext(TennisApiContext);

  const [playoffStage, setPlayoffStage] = useState<IPlayoffProps | null>(null);

  const interval = refreshTimes[dataRefreshTime || 'never'];
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchPlayoff = useCallback(
    (manageLoader: boolean) => {
      if (tournamentId) {
        manageLoader && setIsLoading(true);
        $playoff
          ?.getPlayoff(tournamentId)
          ?.then(({ playoff }: ITennisPlayoffResponse) => {
            manageLoader && setIsLoading(false);
            setPlayoffStage(playoff);
          })
          .catch((error: unknown) => {
            console.error(error);
          });
      } else {
        setPlayoffStage(null);
      }
    },
    [$playoff, tournamentId],
  );

  const refetchWidgetData = useCallback(() => {
    fetchPlayoff(false);
  }, [fetchPlayoff]);

  useInterval(() => {
    refetchWidgetData();
  }, interval);

  useEffect(() => {
    fetchPlayoff(true);
  }, [fetchPlayoff]);

  const showWidget = true;

  return {
    playoffStage,
    refetchWidgetData,
    handleClick: useSubscriptionClick({ dataWidgetId, dataWidgetSport, dataWidgetCuid, subscribers }),
    showWidget,
    isLoading,
  };
}
